import { render, staticRenderFns } from "./ListCertificates.vue?vue&type=template&id=4852e392&scoped=true"
import script from "./ListCertificates.vue?vue&type=script&lang=js"
export * from "./ListCertificates.vue?vue&type=script&lang=js"
import style0 from "./ListCertificates.vue?vue&type=style&index=0&id=4852e392&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4852e392",
  null
  
)

export default component.exports